import React from "react";
import { Link } from "react-router-dom";

const SIDE_IMG = "https://images.unsplash.com/photo-1722805740177-04256b6517f2?w=900&q=80";

export default function AuthLayout({ children, title, subtitle }) {
    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:block relative overflow-hidden linen-bg">
                <div className="absolute inset-0">
                    <img src={SIDE_IMG} alt="" className="w-full h-full object-cover opacity-80" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-navy/40 via-transparent to-navy/60"></div>
                <div className="absolute inset-0 flex flex-col justify-between p-12 text-white">
                    <Link to="/" className="font-serif text-3xl">HolyMarry</Link>
                    <div className="max-w-md">
                        <p className="font-serif text-4xl italic leading-tight">&ldquo;Two are better than one, because they have a good return for their labor.&rdquo;</p>
                        <p className="mt-4 text-xs tracking-[0.25em] uppercase text-gold-300">Ecclesiastes 4:9</p>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center p-6 md:p-12">
                <div className="w-full max-w-md">
                    <div className="lg:hidden mb-8">
                        <Link to="/" className="font-serif text-3xl text-navy">HolyMarry</Link>
                    </div>
                    <div className="text-[11px] tracking-[0.25em] uppercase text-gold-700 font-semibold">{subtitle}</div>
                    <h1 className="mt-3 font-serif text-4xl md:text-5xl text-navy tracking-tighter">{title}</h1>
                    <div className="mt-10">{children}</div>
                </div>
            </div>
        </div>
    );
}
